import styled from "styled-components";

export const SocialMediaItem = styled.li`
  margin-right: 2rem;
  
  img {
    width: 2.7rem;
  }
`;